import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { Toast, ToastrService } from 'ngx-toastr';
import { environment } from './../../../environments/environment';
import { FilesTickets } from './../domain/files';



@Injectable()
export class FilesService {
    constructor(private http: HttpClient, private toastr: ToastrService) {}

    public getFiles(idTicket){
        let url = environment.getFiles;
       return this.http.get(url+idTicket);
    }

    public setAdjuntoPedido(idTicket,idAdjunto){
        let url = environment.setFileToTicket;
        const formData: FormData = new FormData();
        formData.append('idTicket', idTicket);
        formData.append('idAdjunto', idAdjunto);
        return this.http.post(url,formData);
    }

    public upload(files: Array<FilesTickets>, idReferente: number): {[key:string]:Observable<number>} {
        // this will be the our resulting map
        const status = {};
        const url = '/upload/files' + '/'+ idReferente;
       

        files.forEach(fileticket => {
            // create a new multipart-form for every file
            const formData: FormData = new FormData();
            let file = fileticket.file
            formData.append('file', file, file.name);
            formData.append('descripcion', fileticket.descripcion);

            // create a http-post request and pass the form
            // tell it to report the upload progress
            const req = new HttpRequest('POST', url, formData, {
                reportProgress: true
            });

            // create a new progress-subject for every file
            const progress = new Subject<number>();
            const result = new Subject<any>();

            // send the http-request and subscribe for progress-updates
            this.http.request(req).subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {

                    // calculate the progress percentage
                    const percentDone = Math.round(100 * event.loaded / event.total);

                    // pass the percentage into the progress-stream
                    progress.next(percentDone);
                } else if (event instanceof HttpResponse) {
                    //envio el id
                    result.next(event.body);
                    //finalizo con el pedido
                    result.complete();
                    // Close the progress-stream if we get an answer form the API
                    // The upload is complete
                    progress.complete();
                }
            });

            // Save every progress-observable in a map of all observables
            status[fileticket.file.name] = {
                progress: progress.asObservable(),
                id: result.asObservable()
            };
        });


        this.toastr.success('Adjuntos cargados', 'Exito');

        // return the map of progress.observables
        return status;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/files.service.ts